module.exports = __webpack_public_path__ + "img/product-icon3.462136af.png";